import { CGUID, SyncSeekUrl, SyncPullSerializedUrl,SyncSeek_action,SyncMakeGetUrl, SyncPullSerialized_action, SyncSeekSynchronously } from "datasync-core";

import stat_form from './stat_form.json'
import article_form from './article_form.json'
import blog_form from './blog_form.json'
import award_form from './award_form.json'
import video_form from './video_form.json'
import param_form from './param_form.json'
import toolbox_form from './toolbox_form.json'
import hiring_form from './hiring_form.json'
import hiring_contact_form from './hiring_contact_form.json'

const production = true;
const debugging = false;
const debugging_svg = false;
const local = !production;
const rss = false;
const pause_carousel = false;

const globals = {
    dico:{
      analytics_fallback_picture: require("../../Assets/img/placeholders/analytics.jpg"),
      partners_fallback_picture: require("../../Assets/img/placeholders/partners.jpg"),
      hotels_fallback_picture: require("../../Assets/img/placeholders/award2.jpg"),
      video_fallback_picture: require("../../Assets/img/placeholders/video1.jpg"),
      login_background_picture: require("../../Assets/img/placeholders/login-background.jpg"),
      copyright:"© 2025-2026 By le Cercle des Hôteliers Indépendants",
      version:"(v2026-08-19b)"
    },
    context : {
        user_connected:false
    }
    ,
    mailsync : {
      ...(local && {url : 'http://localhost:4404'}),
      ...(production && {url : 'https://adv-mailer-service.thononadvent.com'})
    },
    datasync_service : {
        ...(local && {url : "http://localhost:8888/datasync-service"}),
        ...(production && {url : 'https://rest.datasync.ovh'})
    },

    datasync :{
        /*DATASYNC*/
        /* WIX Toolbox carousel */
        toolbox_company_guid:"573EB481-CB63-23B4-9530-72D6AD3FA690",
        tbx_partners_table_guid:"905C17C7-05B7-6602-E785-1E17043502E7",

        /* Let us use hotels.immo users database */
        h_immo_company_guid:"F446872A-5B88-106E-2721-E5B21EC16C52",
        h_immo_user_table_guid:"6D438E06-4A8C-D39D-AD61-3E021BEA7A40", 

        /* dedicated platform database */
        platform_company_guid:"5CC50B61-3708-94A9-DFE7-E87AA1C8E729",
        pf_stats_table_guid:"CF826AD8-3F0C-34F6-C4F9-7519D4439C67", 
        pf_articles_table_guid:"E43E28E9-8E29-56B2-F893-F7688F1B56B1",
        pf_blogs_table_guid:"1AB531AB-A6A1-58D9-B3A7-225196262401",
        pf_awards_table_guid:"364FA5C2-7EBA-9E97-F05F-C630F8B2761D", 
        pf_videos_table_guid:"6D6676ED-CFC7-99C9-920C-1AEBAF8E426C",
        pf_params_table_guid:"6DA2828B-9269-CB07-877B-73BDB111A4B9",
        pf_hirings_table_guid:"F381A941-138D-CFE7-B1F8-25CF083DBE03",

        /* Let us embed hotels.immo hotels for sale */
        h_immo_company_guid:"F446872A-5B88-106E-2721-E5B21EC16C52",
        h_immo_hotels_table_guid:"18B572CC-2BDB-BBE2-9666-C41F973C8502",
    }
    ,

    error_message:
        {
          "code_104":`Acces refusé, adresse inconnue en base de données`,
          "code_1041":`Acces refusé, présent en base mais non authorisé`
        ,"code_103":`Le code d'authentification n'a pas pu être envoyé à la boite mail spécifiée`
        ,"code_102":`Compte email enregistré en double en base de données`
        ,"code_105":`twofactors_form_submit_handler:: GetFormValue3Tiers(this.state.current_user.data_blob.form) raises error-> #105`
        ,"code_105":"onAdminGranted is not defined"
        ,"code_108":"Accès refusé, le code ne correspond pas à celui envoyé par courriel."
        ,"code_106":"Error -> onAdminDenied is not defined #106"
        ,"code_101":"Le formulaire d'authentification comporte des erreurs de saisie."
        ,"code_100":"Le formulaire comporte une erreur de saisie."},

    links:{
        presse_partenaire:"https://the-blog.fr/",
        blog_thcc:"https://www.hotels-community.info/",
        contact:"https://marketplace-hotel.com/contact",
        partenaires_externes:"https://www.thcc-community.com/expertsetpartenaires",
        forum_blog:"http://www.coronavirus-hotels.info/",
        toolbox:"http://www.toolbox-thcc.com/",
        events:"https://www.coronavirus-hotels.info/conferences-en-ligne-events",
        adhesion_hotels:"https://www.thcc-community.com/copiedehoteliers",
        linked_in:"https://www.linkedin.com/company/thcc-hoteliers-for-hoteliers/?viewAsMember=true",
        facebook:"https://www.facebook.com/lecercle.hotels",
        youtube:"https://www.youtube.com/results?search_query=le+cercle+des+hoteliers+independants",
        le_cercle:"https://www.linkedin.com/groups/10144244/",
        telephone:"https://www.lecercle-hotels.com/"

    },
    parameters : {
                    debugging : debugging, 
                    debugging_svg : debugging_svg, 
                    debugging_state : local,
                    form_version : "2.0",
                    bypass_token:false, 
                    admin_bypass_email:"osteuermann@thcc-eu.com",
                    local:local, 
                    linguee_search_enabled: false, 
                    rich_edit_enabled:true,
                    hiring_contact_feature_enabled:false,
                    max_articles: 3,
                    max_blogs: 3,
                    max_awards: 3,
                    max_toolboxes:200,
                    max_videos:2,
                    max_hirings:3,
                    rss:rss,
                    pause_carousel:pause_carousel,
                    sticky3_debug:false,
                    whatsapp:false
                  },

    website:{
                title:"the market place",
                slogan:"the market place by thcc, la centrale d'achats spécialisée dans l'hôtellerie"
            },
    mailer:{
        ne_pas_repondre_email_next : "ne-pas-repondre@hotellink360.net",
        ne_pas_repondre_email : "ne-pas-repondre@hotels.immo",
        admin_target_email : "thcc_contact_group@marketplace-hotel.com",
        signature:"hotelLink360"
    },
}

const ca_svg_flatten = `<svg viewBox="0 0 48.72 48.72">
  <circle cx="24.36" cy="24.36" r="23.36" style="stroke-width:2px;fill:none;stroke:#0011f8;stroke-miterlimit:10"/>
  <path style="stroke: #0011f8; stroke-miterlimit:10;stroke-width: 1.4px; fill: none;" d="m34.19 14.65 3.6-.01.02 3.6"/>
  <path style="stroke: #0011f8; stroke-miterlimit:10;stroke-width: 1.4px; fill: none;" d="m8.8 31.79 8.95-8.86 6.03 5.89 13.67-13.61"/>
</svg>`;

const icon_svg_room_flatten = `<svg viewBox="0 0 48.72 48.72">
  <circle cx="24.36" cy="24.36" r="23.36" style="stroke-width:2px;fill:none;stroke:red;stroke-miterlimit:10"/>
  <path style="stroke: red; stroke-width: 1.4px; fill: none;" d="M39.06 27.02v-4.83c0-1.02-.83-1.85-1.85-1.85H10.76c-1.02 0-1.85.83-1.85 1.85v4.83H6.92v3.51h34.13v-3.51z"/>
  <path style="stroke: red; stroke-width: 1.4px; fill: none;" d="M8.92 30.52v3.73h2.33l5.17-3.73z"/>
  <path style="stroke: red; stroke-width: 1.4px; fill: none;" d="M39.06 30.52v3.73h-2.2l-5.85-3.73z"/>
  <path style="stroke: red; stroke-width: 1.4px; fill: none;" d="M34.34 11.59c-2.77 0-5.49-.77-7.85-2.21a4.82 4.82 0 0 0-5.02 0 15 15 0 0 1-7.85 2.21h-1.1c-1.17 0-2.11.94-2.11 2.11v6.65h27.14V13.7c0-1.17-.94-2.11-2.11-2.11z"/>
  <path style="stroke: red; stroke-width: 1.4px; fill: none;" d="M21.78 20.34h-7.59a9.2 9.2 0 0 1 0-4.54c2.68-.75 4.91-.75 7.58 0 .38 1.49.38 3.05 0 4.54Z"/>
  <path style="stroke: red; stroke-width: 1.4px; fill: none;" d="M33.78 20.34h-7.59a9.2 9.2 0 0 1 0-4.54c2.68-.75 4.91-.75 7.58 0 .38 1.49.38 3.05 0 4.54Z"/>
</svg>`;

const icon_svg_room = `<svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.72 48.72">
  <defs>
    <style>
      .cls-1 {
        stroke-width: 2px;
      }

      .cls-1, .cls-2 {
        fill: none;
        stroke: #fff;
        stroke-miterlimit: 10;
      }

      .cls-2 {
        stroke-width: 1.4px;
      }
    </style>
  </defs>
  <circle class="cls-1" cx="24.36" cy="24.36" r="23.36"/>
  <g>
    <path class="cls-2" d="m39.06,27.02v-4.83c0-1.02-.83-1.85-1.85-1.85H10.76c-1.02,0-1.85.83-1.85,1.85v4.83h-1.99v3.51h34.13v-3.51h-1.99Z"/>
    <g>
      <polygon class="cls-2" points="8.92 30.52 8.92 34.25 11.25 34.25 16.42 30.52 8.92 30.52"/>
      <polygon style="stroke: pink; stroke-width: 1.4px; fill: none;" points="8.92 30.52 8.92 34.25 11.25 34.25 16.42 30.52 8.92 30.52"/>
      <polygon class="cls-2" points="39.06 30.52 39.06 34.25 36.86 34.25 31.01 30.52 39.06 30.52"/>
    </g>
    <path class="cls-2" d="m34.34,11.59c-2.77,0-5.49-.77-7.85-2.21h0c-1.54-.94-3.48-.94-5.02,0h0c-2.36,1.45-5.08,2.21-7.85,2.21h-1.1c-1.17,0-2.11.94-2.11,2.11v6.65h27.14v-6.65c0-1.17-.94-2.11-2.11-2.11h-1.1Z"/>
    <g>
      <path class="cls-2" d="m21.78,20.34h-7.59c-.38-1.49-.38-3.05,0-4.54,2.68-.75,4.91-.75,7.58,0,.38,1.49.38,3.05,0,4.54Z"/>
      <path class="cls-2" d="m33.78,20.34h-7.59c-.38-1.49-.38-3.05,0-4.54,2.68-.75,4.91-.75,7.58,0,.38,1.49.38,3.05,0,4.54Z"/>
    </g>
  </g>
</svg>`;

const le_cercle_svg_stream = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="269.000000pt" height="271.000000pt" viewBox="0 0 269.000000 271.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,271.000000) scale(0.100000,-0.100000)">
<path style="stroke: none; stroke-width: 1.4px; fill: blue;" d="M1130 2685 c-283 -52 -524 -178 -725 -380 -193 -194 -313 -418 -372
-695 -25 -119 -25 -391 0 -510 59 -276 179 -502 372 -695 204 -205 453 -333
740 -380 103 -17 298 -19 399 -5 556 81 1006 499 1126 1047 l18 81 -47 7 c-25
3 -53 8 -62 11 -14 4 -20 -10 -34 -73 -93 -417 -400 -758 -806 -894 -248 -83
-547 -81 -789 6 -354 128 -641 423 -752 775 -46 146 -53 195 -52 380 0 146 4
190 22 265 103 418 388 737 782 880 242 87 543 90 787 8 315 -105 584 -346
723 -648 36 -76 74 -194 95 -289 6 -28 6 -28 63 -21 31 4 60 9 63 11 9 5 -16
110 -48 209 -112 343 -362 630 -684 788 -203 99 -374 138 -603 136 -77 0 -175
-7 -216 -14z"/>
<path style="stroke: none; stroke-width: 1.4px; fill: blue;" d="M1230 2300 c-103 -13 -188 -38 -285 -85 -138 -65 -135 -62 -91 -122
l38 -49 81 42 c461 239 1019 -5 1168 -511 34 -116 34 -324 0 -440 -110 -374
-458 -624 -836 -602 -300 18 -563 193 -695 460 -60 122 -81 218 -81 362 0 143
21 238 81 361 22 46 40 85 40 87 0 6 -88 67 -97 67 -13 0 -87 -151 -111 -226
-47 -146 -54 -381 -16 -524 148 -558 735 -858 1271 -650 205 79 404 262 506
465 116 231 125 534 24 785 -84 206 -279 409 -485 502 -144 65 -358 98 -512
78z"/>
<path style="stroke: none; stroke-width: 1.4px; fill: blue;" d="M1202 1900 c-138 -36 -252 -117 -330 -235 -117 -175 -132 -390 -41
-581 47 -98 161 -211 260 -259 66 -32 74 -33 80 -18 3 10 16 91 29 180 l23
162 -37 38 c-101 104 -76 275 51 350 39 22 60 28 108 28 129 -1 225 -97 225
-225 0 -62 -18 -106 -63 -156 l-34 -39 27 -175 c21 -136 30 -174 41 -172 34 7
138 66 182 103 120 103 187 242 195 408 6 124 -6 189 -56 291 -115 238 -400
368 -660 300z"/>
</g>
</svg>`;


 /*  Prototype   : SyncPullSerializedSynchronously
    * Parameter     :	JSON object {guid:"Unique synchronisation session id",block_size:"number of data returned in each request/ default return all"
    * Return		:	{remote_data_block:"array of data records"}
    * Purpose 	    : Returns prepared required data since given guid session
    *  History      : Created on 2022-10-24
    *               : 2024-05-11 get url params from p_o_syncPullSerializedParams.SyncPullSerializedGETurl passed back by SyncSeek
    */ 
 const SyncPullSerializedSynchronously = async p_o_syncPullSerializedParams => {
  try {
      if (globals.parameters.debugging)
          console.log(`SyncPullSerializedSynchronously call - ${JSON.stringify(p_o_syncPullSerializedParams)}`)

      let l_o_datasync_PullSerialized = {session_guid: p_o_syncPullSerializedParams.session_guid, block_size: p_o_syncPullSerializedParams.block_size};
      let l_s_sync_object_stringified = JSON.stringify(l_o_datasync_PullSerialized);

      let results = await fetch(`${p_o_syncPullSerializedParams.SyncPullSerializedGETurl} &data_sync=${l_s_sync_object_stringified}`.replace(/[\n\r]/g, '').replace(/\s{1,}/g,''))
      let server_answer_as_object = await results.json();

      if (globals.parameters.debugging){
        console.log("SyncPullSerializedSynchronously::results ->", results)
        console.log("SyncPullSerializedSynchronously::server_answer_as_object ->", server_answer_as_object)
      
        console.log("SyncPullSerializedSynchronously::availables data count:"+ server_answer_as_object.remote_data_block.length);
        console.log("SyncPullSerializedSynchronously::availables data flow:"+ JSON.stringify(server_answer_as_object.remote_data_block));
      }

      if ((server_answer_as_object.remote_data_block) && (server_answer_as_object.remote_data_block.length > 0)){
          
          return(server_answer_as_object.remote_data_block);
      }
      else{
          console.log("SyncPullSerializedSynchronously::failed");
          return({remote_data_block:[]});//Return empty array
      }
  }
  catch(error){
      //Something went wrong
      console.error("SyncPullSerializedSynchronously: failed with error:", error);
  }        
}

/**
   * Prototype: GetDatasyncMediaOneBlockSynchronously2
   * Purpose: Fetch datablob synchronously in one block based on SynPull rather than syncPullSerialized
   * History: copied from GetDatasyncMediaOneBlock on 2024-03-10
   *          one_block_pull parameter deleted on 2024-10-16
   *          on_media_count_callback handler deleted on 2024-10-16
   *          on_media_ready_callback handler deleted on 2024-10-16
   *          on_media_failed_callback handler deleted on 2024-10-16
   * Parameters sync_seek_request_object = {}
   */
  
const GetDatasyncMediaOneBlockSynchronously2 = async (p_sync_seek_request_object) => {
  
  try{
      if (!p_sync_seek_request_object.session_guid) throw("p_sync_seek_request_object.session_guid required in GetDatasyncMediaOneBlock !!!")
      if (!p_sync_seek_request_object.datasync_url) throw("p_sync_seek_request_object.datasync_url required in GetDatasyncMediaOneBlock !!!")
      

      let l_oSyncSeekResult = await SyncSeekSynchronously(
          {
              session_guid : p_sync_seek_request_object.session_guid,
              syncSeekPOSTobject : {POST_ACTION:SyncSeek_action, POST_URL:`${p_sync_seek_request_object.datasync_url}/Sync.php`},
              SyncPullSerializedGETurl : SyncMakeGetUrl(p_sync_seek_request_object.datasync_url, SyncPullSerialized_action), 
              company_guid: p_sync_seek_request_object.company_guid,
              seek_filter_clause:p_sync_seek_request_object.seek_filter_clause,
              table_guid:p_sync_seek_request_object.table_guid
              });

      //return l_oSyncSeekResult;
      if (p_sync_seek_request_object.debugging)
        console.log("l_oSyncSeekResult = ",l_oSyncSeekResult)

      if (l_oSyncSeekResult.available_data_count <= 0){
        //No data available
        console.log("GetDatasyncMediaOneBlockSynchronously2::No data available")
        return [];
      }

      //Create an array of promises according to available media items
      let l_array_PullPromises = [];
    
      l_array_PullPromises.push(SyncPullSerializedSynchronously({
          SyncPullSerializedGETurl:p_sync_seek_request_object.SyncPullSerializedGETurl,
          session_guid : p_sync_seek_request_object.session_guid, 
          block_size: l_oSyncSeekResult.available_data_count}));//Fetch Media data object individually

      //Wait for all promises resolution using Promise.all
      let synchronous_items_array = await Promise.all(l_array_PullPromises).then((media_objects_from_syncPull_promises)=>{
      
          let l_array_media_cache = []; 

          if (p_sync_seek_request_object.debugging){
              console.log(`GetDatasyncMediaOneBlockSynchronously2::JSON.stringify(media_objects_from_syncPull_promises) from DataSync => ${JSON.stringify(media_objects_from_syncPull_promises)}`)
          }

          //Fetch available data asynchronously
          if (media_objects_from_syncPull_promises && media_objects_from_syncPull_promises.length > 0 && media_objects_from_syncPull_promises[0].length > 0)
          {//Conditionned enhanced on 2024-10-16
              media_objects_from_syncPull_promises[0].forEach((media_data) =>{
                try{
                  if (!(media_data && media_data.data_blob && media_data.data_blob.data_tier)) throw ("Invalid media_data");

                  let l_o_data_block = media_data; 
                  
                  if (p_sync_seek_request_object.debugging)
                      console.log("GetDatasyncMediaOneBlockSynchronously2:l_o_data_block:",l_o_data_block)
                  
                  //process synchronously each asynchonous fetched record
                  if (l_o_data_block) //
                        l_array_media_cache.push(l_o_data_block);
                  }
                  catch(e){
                      console.error("GetDatasyncMediaOneBlockSynchronously2:Invalid l_o_data_block.data_blob ",e.message)
                      return null;
                  }
              })
              //Finally send result back Synchronously
              return(l_array_media_cache)
          }     
      })

    return synchronous_items_array;//Return the array of items Synchronously                                
  }
  catch(error){
      //Something went wrong
      console.error("GetDatasyncMediaOneBlockSynchronously2: failed with error:", error);
      return null;
  }
}

export {globals, stat_form, article_form, blog_form, award_form, video_form, toolbox_form, param_form, hiring_form,hiring_contact_form,  GetDatasyncMediaOneBlockSynchronously2,
    ca_svg_flatten, icon_svg_room_flatten, icon_svg_room, le_cercle_svg_stream
}